import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from "../../config/axiosInstance";

export const fetchEcommerceApi = async (data) => {
  const params = Object.entries(data || {}).reduce((acc, [key, value]) => {
    if (value !== "" && value !== undefined && value !== null) acc[key] = value;
    return acc;
  }, {});
  const endPoint = `/admin/ecommerce/list?${new URLSearchParams(params).toString()}`;
  return axios.get(endPoint, setJwtToken());
};

export const addEcommerceApi = async (type, data, multipart = false) => {
  return axios.post(`/admin/ecommerce/${type}`, data, multipart ? setMultiPartHeader() : setJwtToken());
};

export const updateEcommerceApi = async (type, data, multipart = false) => {
  return axios.put(`/admin/ecommerce/${type}`, data, multipart ? setMultiPartHeader() : setJwtToken());
};

export const changeEcommerceStatusApi = async (data) => {
  return axios.put("/admin/ecommerce/status", data, setJwtToken());
};

export const deleteEcommerceApi = async (type, id) => {
  return axios.delete(`/admin/ecommerce/${type}/${id}`, setJwtToken());
};

export const shiprocketEcommerceApi = async (action, data) => {
  return axios.post(`/admin/ecommerce/shiprocket/${action}`, data, setJwtToken());
};

export const cancelEcommerceOrderApi = async (data) => {
  return axios.post("/admin/ecommerce/order/cancel", data, setJwtToken());
};
